import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import "./email.scss";
import InputFormik from "app/pages/.shared/form/InputFormik";

const Email = ({ disabled, blocPrefixName = "" }) => {
	return (
		<div className="email">
			<InputFormik
				type="email"
				name={blocPrefixName ? `${blocPrefixName.toLowerCase()}.email` : "email"}
				id="email"
				data-testid="email-input"
				label={<FormattedMessage id="email.label" />}
				disabled={disabled}
				maxLength={100}
			/>
		</div>
	);
};

Email.propTypes = { disabled: PropTypes.bool, blocPrefixName: PropTypes.string };

export default Email;
